import { createSlice } from '@reduxjs/toolkit';
import { IAerialView } from '../../types/aerialView';

const initialState: IAerialView = {
  placeholders: null,
};

export const aerialViewSlice = createSlice({
  name: 'aerialView',
  initialState,
  reducers: {},
});

export const { reducer: aerialViewReducer } = aerialViewSlice;
